module.exports = __webpack_public_path__ + "370e3737e562ad9dbe1e8c3b9bb1e499.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/march-medal.png
// module id = 1924
// module chunks = 0